"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualisationSchema = exports.VisualisationKeySchema = void 0;
const zod_1 = require("zod");
const VISUALISATION_KEYS = ['eventMap', 'heatMap', 'shotMap', 'passSonar'];
exports.VisualisationKeySchema = zod_1.z.enum(VISUALISATION_KEYS);
const VisualisationMetricSchema = zod_1.z.object({
    metric_key: zod_1.z.string(),
});
exports.VisualisationSchema = zod_1.z.object({
    visualisation_key: exports.VisualisationKeySchema,
    priority: zod_1.z.number(),
    universal: zod_1.z.boolean(),
    visualisation_metrics: zod_1.z.array(VisualisationMetricSchema),
});
//# sourceMappingURL=visualisation.js.map